module.exports = __webpack_public_path__ + "static/media/helpdesk_chatbubbleIcon.92ff8a47.svg";